import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Keep the custom --text-* scale distinct from colours in either class order.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ['control', 'control-compact', 'control-large'],
      text: [
        'display',
        'headline',
        'title',
        'section-title',
        'h1',
        'h2',
        'h3',
        'body',
        'small',
        'identifier',
        'label',
        'grid',
      ],
    },
  },
})

/**
 * Merge class names, letting later Tailwind utilities win over earlier ones.
 *
 * `clsx` handles conditionals; `twMerge` resolves conflicts. Without the second
 * step, `cn('p-2', 'p-4')` emits both and CSS source order decides — which is
 * why a component's own padding sometimes beats the padding a caller passed.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
